import React, { useEffect, useState } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import AddMenuMealItemCompo from "./add-meal-item-form";
import {
  getFoodMenuMealItemsList,
  deleteFoodMenuMealItem,
  getFoodMenuMealList,
} from "./hostelServices/foodMenuServices";
const HostelMenuMealItemsListTable = () => {
  const { toggleHostelMenu, openModal, modalState } = useGlobalState();
  var { id, foodMenuId, mealId } = useParams();
  var { foodMenuId } = useParams();
  var { mealId } = useParams();
  console.log("the meal id : ", mealId);
  console.log("id: and foodmenuiD: ", id, foodMenuId);
  useEffect(() => {
    openModal({
      ...modalState,
      id: id,
      foodMenuId: foodMenuId,
      mealId: mealId,
      menuId: foodMenuId,
    });
    toggleHostelMenu(true);

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getFoodMenuMealItemsList}
        tab1={"Hostel"}
        tab2={"Meal Items"}
        hostelId={id}
        menuId={foodMenuId}
        deleteRow={deleteFoodMenuMealItem}
        mealId={mealId}
        actions={{
          edit: true,
          delete: true,
        }}
        AddForm={AddMenuMealItemCompo}
      />
    </div>
  );
};

export default HostelMenuMealItemsListTable;
